import React, { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from 'react-redux';
import { ThunkDispatch } from "@reduxjs/toolkit";
import { LoadingSpinner } from './../../../components/Icons'
import CustomIconButton from "../../../components/CustomIconButton";
import CustomButton from "../../../components/CustomButton";
import Dropdown from "../../../components/Dropdown";
import { createStatus } from "../../../reducers/talentMypage";

interface IndustryExperienceProps {
    onClose: () => void;
}

const IndustryExperience: React.FC<IndustryExperienceProps> = ({ onClose }) => {
    const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
    const talentMypage = useSelector((state: any) => state.talentMypage)
    const { isLoading, industryOptions } = useSelector((state: any) => state.talentMypage)
    const [isEditing, setIsEditing] = useState(false)
    const [selectedIndustry, setSelectedIndustry] = useState<any>(null);
    const [selectedIndustry2, setSelectedIndustry2] = useState<any>(null);
    const [selectedIndustry3, setSelectedIndustry3] = useState<any>(null);
    const [industry1Options, setIndustry1Options] = useState([]);
    const [industry2Options, setIndustry2Options] = useState([]);
    const [industry3Options, setIndustry3Options] = useState([]);
    const industry2DropdownRef = useRef<HTMLDivElement>(null)
    const industry3DropdownRef = useRef<HTMLDivElement>(null)
    
    useEffect(() => {
        if(talentMypage?.talent && industryOptions) {
            const industry1 = industryOptions.find((item:any) => item?.id === talentMypage?.talent?.industry_1_id);
            const industry2 = industryOptions.find((item:any) => item?.id === talentMypage?.talent?.industry_2_id);
            const industry3 = industryOptions.find((item:any) => item?.id === talentMypage?.talent?.industry_3_id);
            setSelectedIndustry(industry1 || null);
            setSelectedIndustry2(industry2 || null);
            setSelectedIndustry3(industry3 || null);

            setIndustry1Options(industryOptions.filter(item => item.level == 1))

            if(talentMypage?.talent?.industry_1_id) {
                setIndustry2Options(industryOptions.filter(item => item.parent_id == industry1.code && item.level == 2))
            }
            if(talentMypage?.talent?.industry_2_id) {
                setIndustry3Options(industryOptions.filter(item => item.parent_id == industry2.code && item.level == 3))
            }
        }
    }, [talentMypage, industryOptions])

    const checkEditing = () => {
        const selectedId1 = selectedIndustry?.id ?? null;
        const selectedId2 = selectedIndustry2?.id ?? null;
        const selectedId3 = selectedIndustry3?.id ?? null;

        const currentId1 = talentMypage?.talent?.industry_1_id ?? null;
        const currentId2 = talentMypage?.talent?.industry_2_id ?? null;
        const currentId3 = talentMypage?.talent?.industry_3_id ?? null;

        if (selectedId1 === currentId1 &&
            selectedId2 === currentId2 &&
            selectedId3 === currentId3) {
                setIsEditing(false)
                return false
        }
        setIsEditing(true)
        return true
    }

    const saveChangeIndustry = () => {
        if(!checkEditing()) {
            return
        }

        dispatch(createStatus({
            requestBody: { 
                change_job_status_id: talentMypage?.talent?.change_job_status?.id || null, 
                work_parttime_status_id: talentMypage?.talent?.work_part_time_status?.id || null, 
                profession_1_id: talentMypage?.talent?.profession_1_id || null,
                profession_2_id: talentMypage?.talent?.profession_2_id || null,
                profession_3_id: talentMypage?.talent?.profession_3_id || null,
                industry_1_id: selectedIndustry?.id || null,
                industry_2_id: selectedIndustry2?.id || null,
                industry_3_id: selectedIndustry3?.id || null,
                working_style_1_id: talentMypage.talent?.working_style_1_id || null,
                working_style_2_id: talentMypage.talent?.working_style_2_id || null,
                working_style_3_id: talentMypage.talent?.working_style_3_id || null,
                preferred_city_1_id: talentMypage?.talent?.preferred_city_1_id || null,
                preferred_city_2_id: talentMypage?.talent?.preferred_city_2_id || null,
                preferred_city_3_id: talentMypage?.talent?.preferred_city_3_id || null
            },
            }),
        );
        setIsEditing(false)
        onClose();
      };

    const handleChangeIndustryLevel1 = (value) => {
        setSelectedIndustry(value);
        setSelectedIndustry2(null);
        setSelectedIndustry3(null);
        setIsEditing(true)

        // Reload options level 2
        if (value && value.code) {
            setIndustry2Options(industryOptions.filter(item => item.parent_id == value.code && item.level == 2))
        } else {
            setIndustry2Options([])
        }

        // Reload options level 3
        setIndustry3Options([])

        // Forcus to 業種２
        industry2DropdownRef.current?.focus();

        checkEditing();
    }

    const handleChangeIndustryLevel2 = (value) => {
        setSelectedIndustry2(value);
        setSelectedIndustry3(null);
        setIsEditing(true)

        // Reload options level 2
        if (value && value.code) {
            setIndustry3Options(industryOptions.filter(item => item.parent_id == value.code && item.level == 3))
        } else {
            setIndustry3Options([])
        }

        // Forcus to 業種3
        industry3DropdownRef.current?.focus();

        checkEditing();
    }

    return (
        <div className="w-[392px] max-w-full h-full bg-white rounded-2xl pt-3 alu-panel-box-shadow">
            <div className="flex items-center justify-between gap-2 px-4 mb-1">
                <h2 className="text-xl leading-[1.875rem] font-bold alu-text-base-2">経験した業種</h2>
                <CustomIconButton onClick={onClose} customStyle="shrink-0">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                    >
                        <g clipPath="url(#clip0_8574_265)">
                        <path
                            d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z"
                            fill="currentColor"
                        />
                        </g>
                        <defs>
                        <clipPath id="clip0_8574_265">
                            <rect width="24" height="24" fill="white" />
                        </clipPath>
                        </defs>
                    </svg>
                </CustomIconButton>
            </div>
            <div className="overflow-y-auto custom-scrollbar h-[calc(100%-40px)] px-4 pb-4">
                <form className="mt-6 w-full flex flex-col">

                    {/* {isEditing && ( */}
                    <label className="alu-text-base-2 text-sm font-bold mb-2">業種１</label>
                    <Dropdown
                        options={industry1Options}
                        value={selectedIndustry}
                        onChange={(value: any) => handleChangeIndustryLevel1(value)}
                        placeholder="選択してください"
                        inputWidth="full"
                        customStyle="mb-4"
                        optionsFixedWidth={true}
                    />
                    <label className="alu-text-base-2 text-sm font-bold mb-2">業種２</label>
                    <Dropdown
                        options={industry2Options}
                        value={selectedIndustry2}
                        onChange={(value: any) => handleChangeIndustryLevel2(value)}
                        placeholder="選択してください"
                        inputWidth="full"
                        customStyle="mb-4"
                        optionsFixedWidth={true}
                        disabled={!selectedIndustry}
                    />
                    <label className="alu-text-base-2 text-sm font-bold mb-2">業種３</label>
                    <Dropdown
                        options={industry3Options}
                        value={selectedIndustry3}
                        onChange={(value: any) => {setSelectedIndustry3(value); checkEditing();}}
                        placeholder="選択してください"
                        inputWidth="full"
                        customStyle="mb-10"
                        optionsFixedWidth={true}
                        disabled={!selectedIndustry2}
                    />
                    
                    <div className="flex items-center justify-between gap-4">
                        <CustomButton
                            type="button"
                            onClick={() => onClose()}
                            width="full"
                            variant="outline"
                            size="md"
                        >
                            キャンセル
                        </CustomButton>
                        <CustomButton
                            type="button"
                            onClick={() => saveChangeIndustry()}
                            disabled={isLoading || !isEditing || !selectedIndustry?.id || !selectedIndustry2?.id || !selectedIndustry3?.id}
                            width="full"
                            size="md"
                        >
                            <p>{isLoading ? "保存中..." : "保存"}</p>
                            {isLoading && (
                                <span><LoadingSpinner /></span>
                            )}
                        </CustomButton>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default IndustryExperience;